import React, { useEffect, useLayoutEffect } from 'react';
import { createFocusTrap, DEFAULT_IDS_TO_PERSIST } from '../utils/createFocusTrap';
import { trySetFocusOnElement } from 'dom-utils/lib/utils/focusUtils';

export interface FocusTrapStateParams {
    ariaHidden: boolean;
    display: string;
}

interface FocusTrapZoneProps {
    /**
     * The id of the trapzone to be created
     */
    id: string;
    /**
     * Element to focus on open of the element
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    focusOnOpen?: React.RefObject<any>;

    /**
     * Element to focus on close of the focus trap zone
     */
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any --
     * See aka.ms/mini-lint-errors
     *	> Unexpected any. Specify a different type. */
    focusOnClose?: React.RefObject<any>;

    /**
     * ids to not be hidden
     */
    idsToPersist?: string[];

    /**
     * If true, the elements outside the focus trap zone will be made invisible
     */
    hideBackground?: boolean;
}

export const FocusTrapZone: React.FunctionComponent<FocusTrapZoneProps> = (props): JSX.Element => {
    const {
        id,
        children,
        focusOnClose,
        focusOnOpen,
        idsToPersist = DEFAULT_IDS_TO_PERSIST,
        hideBackground = false,
    } = props;

    useLayoutEffect(
        () => {
            const relinquishFocusTrap = createFocusTrap(id, hideBackground, idsToPersist);

            return relinquishFocusTrap;
        },
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * undefined
         *	> React Hook useLayoutEffect has missing dependencies: 'createFocusTrap' and 'relinquishFocusTrap'. Either include them or remove the dependency array. */
        [
            /** kept empty to ensure this happens only on component mount and unmount */
        ]
    );

    useEffect(() => {
        focusOnOpen && trySetFocusOnElement(focusOnOpen);

        return () => {
            focusOnClose && trySetFocusOnElement(focusOnClose);
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps --
         * undefined
         *	> React Hook useEffect has missing dependencies: 'focusOnClose' and 'focusOnOpen'. Either include them or remove the dependency array. */
    }, [id /** re-focus when id changes ie when SeriesDetails is opened or closed */]);

    return <>{children}</>;
};
